// Types
import type { TGetTooltipPosition } from './Tooltip.type';

// Constants
import { TOOLTIP_POSITION } from './Tooltip.constant';

export const getTooltipPosition: TGetTooltipPosition = (params) => {
	const { position, tooltipHeight, tooltipWidth, targetHeight, targetWidth, targetTop, targetLeft } = params;

	switch (position) {
		case TOOLTIP_POSITION['top-left']: {
			return {
				top: targetTop - tooltipHeight,
				left: targetLeft,
			}
		}
		case TOOLTIP_POSITION['top-right']: {
			return {
				top: targetTop - tooltipHeight,
				left: targetLeft + targetWidth - tooltipWidth,
			}
		}
		case TOOLTIP_POSITION['right-top']: {
			return {
				top: targetTop,
				left: targetLeft + targetWidth,
			}
		}
		case TOOLTIP_POSITION['right-center']: {
			return {
				top: targetTop + targetHeight / 2 - tooltipHeight / 2,
				left: targetLeft + targetWidth,
			}
		}
		case TOOLTIP_POSITION['right-bottom']: {
			return {
				top: targetTop + targetHeight - tooltipHeight,
				left: targetLeft + targetWidth,
			}
		}
		case TOOLTIP_POSITION['bottom-left']: {
			return {
				top: targetTop + targetHeight,
				left: targetLeft,
			}
		}
		case TOOLTIP_POSITION['bottom-center']: {
			return {
				top: targetTop + targetHeight,
				left: targetLeft + targetWidth / 2 - tooltipWidth / 2,
			}
		}
		case TOOLTIP_POSITION['bottom-right']: {
			return {
				top: targetTop + targetHeight,
				left: targetLeft + targetWidth - tooltipWidth,
			}
		}
		case TOOLTIP_POSITION['left-top']: {
			return {
				top: targetTop,
				left: targetLeft - tooltipWidth,
			}
		}
		case TOOLTIP_POSITION['left-center']: {
			return {
				top: targetTop + targetHeight / 2 - tooltipHeight / 2,
				left: targetLeft - tooltipWidth,
			}
		}
		case TOOLTIP_POSITION['left-bottom']: {
			return {
				top: targetTop + targetHeight - tooltipHeight,
				left: targetLeft - tooltipWidth,
			}
		}
		default: {
			return {
				top: targetTop - tooltipHeight,
				left: targetLeft + targetWidth / 2 - tooltipWidth / 2,
			}
		}
	}
}
